// extracted by mini-css-extract-plugin
module.exports = {"modal":"MyBoard_modal__Pg6lp"};